//import {Factory} from './factory';
"use strict";
// Use the factory to get a singleton of the manipulator
var manipulator_1 = require("./manipulator");
exports.Manipulator = manipulator_1.Manipulator;
//export let ManipulatorFactory = Factory; 
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxvQ0FBb0M7O0FBRXBDLHdEQUF3RDtBQUN4RCw2Q0FBMEM7QUFBbEMsb0NBQUEsV0FBVyxDQUFBO0FBQ25CLDBDQUEwQyJ9


//////////////////
// WEBPACK FOOTER
// ./src/Kaavio/manipulator/index.ts
// module id = 689
// module chunks = 0